import {
  CommonUrlParams,
  SortDefault,
} from '../../../../interfaces/common-interfaces';
import { convertDate } from '../common-functions';

export const getCommonUrl = (
  args: CommonUrlParams,
  queryString: string,
  date = 'dataFillimit',
  defaultSort?: SortDefault,
) => {
  let hasFilter = false;

  const eqOperators = [
    'actionName',
    'actionType',
    'roli',
    'kategoria',
    'burimiFinancimit',
    'statusTrajnimi',
    'vitiAkademikId',
    'kategori',
    'nenKategori',
    'statusProgramiTematik',
    'programTematikKalendarId',
    'emriPjesemarres',
    'funksioni',
    'institucioniId',
    'trajnimiId',
    'pjesemarresId',
    'vitiKonkurrimitId',
    'konkurrentiId',
    'lendeKonkurimi',
    'lendaAkademikeId',
    'lendeGjyqId',
    'klasaId',
    'studentiId',
    'pedagogId',
    'lendaTemaId',
    'klasaStudentId',
    'moduliId',
    'llojiKlasa',
    'lendeGjyqKlinikaId',
    'dorezuarNeKohe',
    'pedagogPergjegjesId',
    'llojLenda',
  ];
  const ilikeOperators = [
    'emertimi',
    'tema',
    'emri',
    'mbiemri',
    'personiEmri',
    'personEmri',
    'personMbiemri',
    'personiMbiemri',
    'statusKonkurrent',
    'emri',
    'emriStudenti',
    'emriMbiemri',
    'emriPlote',
  ];

  if (args.page) {
    ({ queryString, hasFilter } = addFilter(
      queryString,
      `page=${args.page}`,
      hasFilter,
    ));
  }

  if (args.size && args.size !== 10) {
    ({ queryString, hasFilter } = addFilter(
      queryString,
      `size=${args.size}`,
      hasFilter,
    ));
  }

  if (args.regjistruar) {
    ({ queryString, hasFilter } = addFilter(
      queryString,
      `regjistruar=${args.regjistruar}`,
      hasFilter,
    ));
  }

  if (args.eshteTrajnues) {
    ({ queryString, hasFilter } = addFilter(
      queryString,
      `eshteTrajnues=${args.eshteTrajnues}`,
      hasFilter,
    ));
  }

  if (args.dorezuarNeKohe !== undefined) {
    ({ queryString, hasFilter } = addFilter(
      queryString,
      `dorezuarNeKohe=${args.dorezuarNeKohe}`,
      hasFilter,
    ));
  }

  if (args.sortField || defaultSort) {
    const field = args.sortField || defaultSort?.field;
    const order = args.sortOrder || defaultSort?.order || 'asc';
    ({ queryString, hasFilter } = addFilter(
      queryString,
      `sort=${field}:${order}`,
      hasFilter,
    ));
  }

  const params: (keyof CommonUrlParams)[] = [
    'page',
    'size',
    'sortField',
    'dorezuarNeKohe',
    'eshteTrajnues',
    'regjistruar',
  ];

  Object.entries(args).forEach(([key, value]) => {
    if (typeof value === 'number' && value <= 0) {
      return;
    }

    if (
      value &&
      String(value).length > 0 &&
      !params.includes(key as keyof CommonUrlParams)
    ) {
      switch (key) {
        case 'from':
        case 'dataFilterFillimi':
        case 'trajnimDataFillimit':
          ({ queryString, hasFilter } = addFilter(
            queryString,
            `filter=${date}:gte:${convertDate(String(value))}`,
            hasFilter,
          ));
          break;
        case 'to':
        case 'dataFilterMbarimi':
        case 'trajnimDataPerfundimit':
          ({ queryString, hasFilter } = addFilter(
            queryString,
            `filter=${date}:lte:${convertDate(String(value))}`,
            hasFilter,
          ));
          break;

        default:
          if (Array.isArray(value)) {
            const inValues = value.join(';');
            ({ queryString, hasFilter } = addFilter(
              queryString,
              `filter=${key}:in:${inValues}`,
              hasFilter,
            ));
          }
          if (eqOperators.includes(key)) {
            ({ queryString, hasFilter } = addFilter(
              queryString,
              `filter=${key}:eq:${value}`,
              hasFilter,
            ));
          } else if (ilikeOperators.includes(key)) {
            ({ queryString, hasFilter } = addFilter(
              queryString,
              `filter=${key}:ilike:${value}`,
              hasFilter,
            ));
          }
          break;
      }
    }
  });

  return queryString;
};

export const addFilter = (
  queryString: string,
  filter: string,
  hasFilter: boolean,
) => {
  if (!hasFilter) {
    queryString += `?${filter}`;
    hasFilter = true;
  } else {
    queryString += `&${filter}`;
  }
  return { queryString, hasFilter };
};
